import { createRequest, RequestConfig } from '../../../core/libs/api';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/unauth/get_trips',
};

type GetTripsRequestParams = {
  stationFromId: number | null;
  stationToId: number | null;
  lowDate: string | null;
  highDate: string | null;
};

export const getTripsRequest = (params: GetTripsRequestParams) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify({ filter: params }),
  });
